// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-fluid[data-v-07c323c5] {\n    margin-left: 0;\n}\n.col-form-label[data-v-07c323c5] {\n    width: 80px;\n}\n.fixed-bottom[data-v-07c323c5] {\n    padding: 4px 0;\n}\n", ""]);
// Exports
module.exports = exports;
